import { common, baseComponents } from '@tencent/ceiba-base-components';
import Vue from 'vue';

let loginManagerInstance = null;

function loginByQQ(loginManager) {
  loginManager.mobileLoginByQQConnect({
    appId: '101813972',
    redirectUri: 'https://supercore.qq.com/comm-htdocs/login/qc_redirect.html',
    sUrl: location.href,
  });
  localStorage.curPlatform = 'qq';
}
function loginByWx(loginManager) {
  const option = {
    appId: 'wxfb66a4e99e630765',
    scope: 'snsapi_userinfo',
    sUrl: location.href,
    userinfoSpan: 'userinfo',
    forcePopup: true,
    snapShotTips: true,
    snapShotCustomTips: '我同意“本活动获取您的个人信息，仅用于该活动的领取、发货等操作”',
  };
  loginManager.mobileLoginByWX(option);
  localStorage.curPlatform = 'wx';
}

export default class LoginBase {
  async initLogin() {
    window.ams_login_avoid_conflict = true;
    console.log('LoginBase initLogin begin');
    return await new Promise((resolve) => {
      console.log('supercore initLogin begin');
      console.log('Vue.prototype.$actInfo.layout_type', Vue.prototype.$actInfo.layout_type);
      if (Vue.prototype.$actInfo.layout_type === 'c-supercore-page-qqroom') {
        // 当页面为QQ大厅使用QQ-PT登录
        window.iUseQQConnect = 0;
      } else {
        // 其他情况使用QQ-互联登录
        window.iUseQQConnect = 1;
      }
      // window.iUseQQConnect = common.tool.getCookie('acctype') === 'qc' ? 1 : 0;
      loginManagerInstance = new Vue.prototype.$miloLoginManager({
        commonParams: {
          iUseQQConnect: window.iUseQQConnect,
          useAppLogin: ['tgclub'],
        },
        mobileParams: {
          oWXParams: {
            gameDomain: 'supercore.qq.com',
            appId: 'wxfb66a4e99e630765',
            scope: 'snsapi_userinfo',
            sUrl: location.href,
          },
          oQQConnectParams: {
            appId: '101813972',
            redirectUri: 'https://supercore.qq.com/comm-htdocs/login/qc_redirect.html',
            sUrl: location.href,
          },
        },
      });
      resolve();
    });
  }

  async login(params = { loginType: 'qq' }) {
    console.log('LoginBase login|params=', params);
    if (params.loginType === 'qq') loginByQQ(loginManagerInstance);
    if (params.loginType === 'wx') loginByWx(loginManagerInstance);
  }
  async checkLogin(params) {
    console.log('LoginBase checkLogin|params=', params);
    return await new Promise((resolve) => {
      console.log('loginManagerInstance', loginManagerInstance);

      if (location.href.indexOf('FLUSH_COOKIE=') > 0) {
        common.tool.clearAllCookie();
        let newHref = location.href;
        newHref = common.tool.setUrlParam('FLUSH_COOKIE', '', newHref);
        location.href = newHref;
      }
      const appid = common.tool.getQueryparams('appid');
      const openid = common.tool.getQueryparams('openid');
      const acctype = common.tool.getQueryparams('acctype');
      const accessToken = common.tool.getQueryparams('access_token');

      if (appid && openid && acctype && accessToken) {
        // 写cookie
        // const cookies = `appid=;openid=3086137608;acctype=qq;access_token=@ZrbIlXNOI`;
        let changeAcctype = acctype;
        if (acctype === 'qq' && accessToken.length > 10) changeAcctype = 'qc';
        if (acctype === 'weixin') changeAcctype = 'wx';
        const cookies = `appid=${appid};openid=${openid};acctype=${changeAcctype};access_token=${accessToken}`;
        console.log('default url pass cookie=', cookies);
        common.tool.setCookies(cookies);
        resolve({
          isLogin: true,
          userInfo: {
            nickName: common.tool.getQueryparams('nickname') || '当前用户',
          },
        });
        return;
      };

      loginManagerInstance.checkRealLogin().then((res) => {
        const { isLogin, userInfo, result } = res;
        console.log('checkRealLogin', userInfo);
        // 同步一份loginType到userInfo,兼容旧组件逻辑
        userInfo.loginType = result.loginType;
        // 采用localStorage 保持登录的连续性 保持活动页面上一次保持登录的方式
        let { curPlatform } = localStorage;
        console.log('checkRealLogin curPlatform from localStorage ', curPlatform);

        if (!curPlatform) {
          curPlatform = Vue.prototype.$platform.isWX ? 'wx' : 'qq';
        }
        console.log('checkRealLogin curPlatform ', curPlatform);
        resolve({
          isLogin,
          userInfo,
        });
      })
        .catch((err) => {
          console.error('checkRealLogin Failed Code:', err.errCode);
          console.error('checkRealLogin Failed info:', err.errInfo);
          common.tool.clearAllCookie();
          resolve({
            isLogin: false,
            userInfo: {},
          });
        });
    });
  }
  async logout(params) {
    console.log('LoginBase logout|params=', params);
    await loginManagerInstance.logout().then((res) => {
      // ios存在登出链接地址异常问题
      common.tool.clearAllCookie();
      console.log('supercore user logout res:', res);
      sessionStorage.setItem('logouted', 'true');
      const url = window.location.href.split('?')[0];
      window.location.href = url;
    });
  }
  async checkRoleInfo(params) {
    console.log('LoginBase checkRoleInfo|params=', params);
    return await new Promise(async (resolve) => {
      console.log('Vue.prototype.$actInfo.game_code', Vue.prototype.$actInfo);
      const localStorageCeiba = JSON.parse(window.localStorage.getItem(`ceiba-${Vue.prototype.$actInfo.activity_id}-${Vue.prototype.$actInfo.game_code}`)) || {
        gameCode: null,
        sArea: null,
        sPartition: null,
        sRoleId: null,
      };
      console.log('ceiba-localStroage ==', localStorageCeiba);

      const { gameCode, sArea, sPartition, sRoleId } = localStorageCeiba;
      console.log('sPartition=', sPartition, 'sRoleId=', sRoleId, 'sArea=', sArea, 'gameCode=', gameCode);
      try {
        if (sRoleId) {
          const roleList = await baseComponents.Apis.Role.fetch({
            game_code: gameCode,
            partition_id: sPartition,
            device: common.platform.device,
          });
          console.log('fetch roleList = ', roleList);
          const roleInfo = roleList.find((e) => {
            if (e.role_id === sRoleId) return true;
            if (e.game_open_id === e.role_id) return true;
            if (e.game_open_id === decodeURI(e.role_id)) return true;
            return false;
          });
          if (roleInfo) {
            resolve({
              defaultPlugin: false,
              isRoleReady: true,
              roleInfo,
            });
          }
          console.log('fetch current roleInfo nil', roleInfo);
        } else {
          console.log('fetch current roleInfo vacancy');
          resolve({
            defaultPlugin: true,
            isRoleReady: false,
            roleInfo: {},
          });
        }
      } catch (e) {
        console.log('fetch roleList fail, e=', e);
        resolve({
          defaultPlugin: true,
          isRoleReady: false,
          roleInfo: {},
        });
      }
    });
  }
}
